import { PayoutWalletBalance, WithdrawRequestList } from '../components'

export const WithdrawRequests = () => {
    return (
        <div className='grid grid-cols-1 gap-4'>
            <div className='flex flex-col items-center gap-2 text-[0.6rem] font-bold'>
                <div className='font-bold uppercase'>Payout wallets</div>
                <div className='flex flex-col md:flex-row items-center gap-4'>
                    <PayoutWalletBalance currency='usdc-spl' />
                    <PayoutWalletBalance currency='solana' />
                </div>
            </div>

            {/* The confirmed-fraud-cluster filter is gone. A cluster is
                already reported on the request it belongs to, where the
                reviewer is looking; as a filter over the whole queue it was a
                switch nobody flipped, above a queue that is now grouped by
                what needs attention anyway. */}
            <WithdrawRequestList.AdminTemplate />
        </div>
    )
}
